<template>
	<div class="homePage-certificate">
		<el-row>
			<el-col class="en">
				HONOR DISPLAY
			</el-col>
			<el-col class="ch">
				<img src="/img/rongyu.png" draggable="false" />
			</el-col>
			<el-col>
				<marquee behavior="Scroll" scrollamount="10" class="certificateList" onMouseOut="this.start()" onMouseOver="this.stop()">
					<div v-for="item in newRongyuList" class="certificate">
						<img :src='item.fileUrl' draggable="false"></img>
						<div class="name">{{item.name}}</div>
					</div>
				</marquee>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import rongyu from '@/assets/rongyu.js'
	export default {
		data() {
			return {
				newRongyuList: []
			}
		},
		created() {
			this.newRongyuList = rongyu
		}
	}
</script>

<style lang="scss">
	.homePage-certificate {
		height: 500px;
		text-align: center;

		.en {
			padding-top: 70px;
			font-size: 36px;
			color: #D9D3D3;
			padding-bottom: 10px;
		}

		.ch {
			color: #323232;
			font-size: 20px;
			font-weight: bold;
		}

		.certificateList {
			width: 1440px;
			margin: 40px auto;
			height: 250px;
			position: relative;


			.certificate {
				margin: 0px 5px;
				width: 336px;
				height: 230px;
				float: left;
				color: #000;
				cursor: pointer;
				padding-top: 30px;

				img {
					border-radius: 8px;
					width: 100%;
					height: 190px;
				}

				.name {
					font-size: 16px;
					text-align: center;
					height: 40px;
					line-height: 40px;
				}
			}

			.certificate:hover {
				// transform: scale(1.1);
				margin-top: -30px;
				transition: 0.5s;
			}
		}
	}
</style>